export default "__VITE_ASSET__4ej0OS5M__"